import {getColorByPath, type TextSize, type ThemeColorPath} from 'platform/foundation';
import {cn, cva} from 'platform/shared';

import {suffixTestId, type TestIdProps} from 'shared/web';

import {useComponentsTheme} from '../../../hooks/useComponentsTheme';

interface FlagLabelProps extends TestIdProps {
  size: TextSize;
  color: ThemeColorPath;
  label: string;
  isBold?: boolean;
}

const flagLabelVariants = cva(
  'block overflow-hidden text-ellipsis whitespace-nowrap [font-family:var(--font-family-body)] tracking-[0]',
  {
    variants: {
      size: {
        large: 'text-[length:var(--text-size-large)] leading-[var(--text-leading-large)]',
        base: 'text-[length:var(--text-size-base)] leading-[var(--text-leading-base)]',
        small: 'text-[length:var(--text-size-small)] leading-[var(--text-leading-small)]',
        xSmall: 'text-[length:var(--text-size-x-small)] leading-[var(--text-leading-x-small)]',
        xxSmall: 'text-[length:var(--text-size-xx-small)] leading-[var(--text-leading-xx-small)]',
      },
      isBold: {
        true: 'font-[var(--font-weight-bold)]',
        false: 'font-[var(--text-weight-default)]',
      },
    },
  }
);

export function FlagLabel(props: FlagLabelProps) {
  const theme = useComponentsTheme();

  return (
    <div
      data-testid={suffixTestId('flagLabel', props)}
      className={cn(flagLabelVariants({size: props.size, isBold: Boolean(props.isBold)}))}
      style={{color: getColorByPath(props.color, theme) ?? 'transparent'}}
    >
      {props.label}
    </div>
  );
}
